<template>
  <!-- 技术人员 -->
  <div>
    <block>
      <div id="registeredPersonnelCount" style="position: relative;height: 0;overflow: hidden;top: -120px;"></div>
      <div class="table-list-title dis-bet-cen">
        <div>技术人员 <span style="color: #5D6FE9;">{{page.total}}</span></div>
        <el-select v-model="personnelValue" placeholder="请选择" @change="handlePersonSelect" v-show="!fuzzyDataShow && !returnLimit">
            <el-option label="全部" value="0">全部</el-option>
            <el-option
              v-for="(item, index) in personnelOption"
              :key="index"
              :label="item.label"
              :value="item.value">
              <span style="float: left">{{ item.label }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ item.num }}</span>
            </el-option>
          </el-select>
      </div>
      <el-table
        border
        :data="TableData"
        :cell-style="cellStyle"
        :header-cell-style="headerColor"
        style="width: 100%;">
        <el-table-column type="index" width="50" label="序号"></el-table-column>
        <el-table-column v-for="(item,index) in tableHeader" :key="index" :label="item.label" :property="item.property" align="center">
          <template #default="scope">
            <span>{{scope.row[scope.column.property] || '-'}}</span>
          </template>
        </el-table-column>
        <template #empty style="width: 100%;">
          <gaussian-blur-empty-login @loginEmit="loginEmit" v-show="!islogin"></gaussian-blur-empty-login>
          <gaussian-blur-empty-vip @loginEmit="loginEmit" v-show="fuzzyDataShow && returnLimit"></gaussian-blur-empty-vip>
          <gaussian-blur-empty-vip @loginEmit="loginEmit" v-show="!fuzzyDataShow && returnLimit && TableData.length == 0"></gaussian-blur-empty-vip>
        </template>
      </el-table>
      <gaussian-blur-empty-vip @loginEmit="loginEmit" v-show="!fuzzyDataShow && returnLimit && TableData.length > 0"></gaussian-blur-empty-vip>
      <div class="table-page" v-show="!fuzzyDataShow && !returnLimit">
        <el-pagination
          background
          hide-on-single-page="true"
          :page-size="10"
          :pager-count="7"
          layout="prev, pager, next"
          v-model:currentPage="page.pageNum"
          @current-change="pageChange"
          :total="page.total">
        </el-pagination>
      </div>
    </block>
  </div>
</template>

<script>
import { forwardBG, oldForwardBG } from '@/api/forward.js'
import GaussianBlurEmptyLogin from '@/components/gaussian-blur/gaussian-blur-empty-login'
import GaussianBlurEmptyVip from '@/components/gaussian-blur/gaussian-blur-empty-vip'
import { mapGetters } from 'vuex'
export default {
  setup (props, context) {
    function loginEmit () {
      context.emit('loginEmit', 'company')
    }
    return {
      loginEmit
    }
  },
  components: { GaussianBlurEmptyLogin, GaussianBlurEmptyVip },
  name: 'registered-personnel-count',
  props: { companyId: String, num: Number },
  data () {
    return {
      page: {
        total: this.num ? this.num : 0,
        pageNum: 1
      },
      // 人员分类
      personnelOption: [],
      personnelValue: '0',
      // 股东信息
      tableHeader: [{
        label: '姓名',
        property: 'name'
      }, {
        label: '注册类别',
        property: 'registeredType'
      }, {
        label: '注册专业',
        property: 'registeredProfessional'
      }, {
        label: '执业印章号',
        property: 'certificateno'
      }, {
        label: '有效期至',
        property: 'validPeriod'
      }],
      TableData: [],
      islogin: false,
      returnLimit: false,
      fuzzyDataShow: false
    }
  },
  computed: {
    ...mapGetters([
      'vipData', // 会员数据
      'idToken',
      'userInfo'
    ]),
    vipLevelChange: function () {
      const vm = this
      if (vm.vipData && JSON.parse(vm.vipData)) {
        return JSON.parse(vm.vipData).vipLevel
      } else {
        return null
      }
    }
  },
  watch: {
    idToken: {
      handler (val, oldval) {
        if (val) {
          if (this.idToken) {
            this.islogin = true
            this.initData()
          } else {
            this.islogin = false
          }
        }
      }
    },
    vipLevelChange: function (newValue, oldValue) {
      if (this.idToken) {
        this.islogin = true
        this.initData()
      } else {
        this.islogin = false
      }
    }
  },
  mounted () {
    this.initArrangementRadioValueArr()
    if (this.idToken) {
      this.islogin = true
      this.initData()
    } else {
      this.islogin = false
    }
  },
  methods: {
    handlePersonSelect () {
      this.page.pageNum = 1
      this.initData()
    },
    // 获取所有人员分类
    initArrangementRadioValueArr () {
      const vm = this
      const data = {
        dateBackgroundUrl: '/esPersonnel/getESPersonnelNumber',
        dateBackgroundRequestType: 'get',
        data: {
          companyId: vm.companyId
        }
      }
      forwardBG(data).then(result => {
        if (result.code === 0) {
          const res = result.data
          const arr = []
          res.forEach(item => {
            if (item.parentId === '0' && item.number > 0) {
              const obj = {
                label: item.name,
                value: item.id,
                num: item.number
              }
              arr.push(obj)
            }
          })
          vm.personnelOption = arr
        }
      }).catch(error => {
        console.log(error)
      })
    },
    // 表格设置样式
    headerColor: function ({ row, column, rowIndex, columnIndex }) {
      return 'background-color:#E8EBFC;color:#666666;font-size:14px;text-align:center'
    },
    cellStyle: function ({ row, column, rowIndex, columnIndex }) {
      return 'text-align:center'
    },
    pageChange (e) {
      this.page.pageNum = e
      this.initData()
    },
    initData: function () {
      const vm = this
      const data = {
        dateBackgroundUrl: '/esPersonnel/getESPersonnelDetailsListByModel',
        dateBackgroundRequestType: 'get',
        data: {
          companyId: vm.companyId,
          pageNum: vm.page.pageNum,
          pageSize: 10,
          parentRelevancyId: vm.personnelValue !== '0' ? vm.personnelValue : null
        }
      }
      oldForwardBG(data).then(result => {
        if (result.code === 0 || result.code === 97 || result.code === 98) {
          if (result.code === 97) {
            vm.returnLimit = true
            vm.fuzzyDataShow = false
          } else if (result.code === 98) {
            vm.returnLimit = true
            vm.fuzzyDataShow = true
          } else {
            vm.returnLimit = false
            vm.fuzzyDataShow = false
          }
          const res = result.data
          const arr = []
          vm.page.total = res[0].dataTotal
          res.forEach(item => {
            item.validPeriod = item.validPeriod ? item.validPeriod.substring(0, 10) : '-'
            arr.push(item)
          })
          vm.TableData = arr
        }
      }).catch(error => {
        console.log(error)
      })
    }
  }
}
</script>

<style scoped="scoped" lang="less">
.table-list-title {
  padding: 18px 0;
  text-align: left;
  color: #333;
  font-weight: bold;
  font-size: 16px;
}
.table-page {
  text-align: right;
  margin-top: 10px;
}
/deep/ .el-table__empty-text {
  width: 100%;
}
</style>
